const publicMaterial = {
  'pages.platform.user.staff.name': 'Staff Name',
}

export default publicMaterial
